module.exports = __webpack_public_path__ + "img/qr-slide-bg3.6e6871b7.png";